import useSWR from "swr";
import * as base from "./lib/baseActions";
import { apiEndpoints } from "config/config";

export interface ContactParams{
  contID: number,
  usrID: number,
}

export interface ContactInfo {
  contTitle: string,
  contChristianNames: string,
  contSurname: string,
  contDob: Date,
}

export interface IsHRParams {
  usrID: number;
}

const getContactInfo = async (params: ContactParams): Promise<ContactInfo> => {
  const result = await base.get(apiEndpoints.getContactInfo, { params });
  return result.data;
};

const useGetContactInfo = (params?: ContactParams, p0?: { enabled: boolean; }) => {
  const shouldFetch = !!params?.contID && !!params?.usrID && p0?.enabled !== false;
  
  const fetcher = async ([url, params]: [string, ContactParams]) => {
    const result = await getContactInfo(params);
    return result;
  };
  
  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch ? [apiEndpoints.getContactInfo, params] : null,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );
  
  return {
    data,
    error,
    isLoading: !error && !data,
    isValidating,
    mutate,
  };
};


const getIsHR = async (params: IsHRParams): Promise<boolean> => {
  const result = await base.get(apiEndpoints.getIsHR, { params });
  return result.data;
};

const useGetIsHR = (params?: IsHRParams, p0?: { enabled: boolean }) => {
  const shouldFetch = !!params?.usrID && p0?.enabled !== false;

  const fetcher = async ([url, params]: [string, IsHRParams]) => {
    return await getIsHR(params);
  };

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch ? [apiEndpoints.getIsHR, params] : null,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );

  return {
    isHR: data,
    error,
    isLoading: !error && data === undefined,
    isValidating,
    mutate,
  };
};


export {
  useGetContactInfo,
  useGetIsHR
};